import { render, staticRenderFns } from "./MainSearch.vue?vue&type=template&id=3c2851fb&lang=pug"
import script from "./MainSearch.vue?vue&type=script&lang=js"
export * from "./MainSearch.vue?vue&type=script&lang=js"
import style0 from "./MainSearch.vue?vue&type=style&index=0&id=3c2851fb&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2851fb')) {
      api.createRecord('3c2851fb', component.options)
    } else {
      api.reload('3c2851fb', component.options)
    }
    module.hot.accept("./MainSearch.vue?vue&type=template&id=3c2851fb&lang=pug", function () {
      api.rerender('3c2851fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainSearch.vue"
export default component.exports